import { FC, memo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { SubscribeButton } from '@/components/molecules/SubscribeButton'

import { appConfig } from '@/services/config'
import { UserInfo } from '@/services/user'

interface ISubscriptionButtonWithTipComponentProps {
  userInfo: UserInfo
  amount: number
  activityId?: string
}
const SubscriptionButtonWithTipComponent: FC<
  ISubscriptionButtonWithTipComponentProps
> = ({ userInfo, amount, activityId }) => {
  const { t } = useTranslation('common')
  const currency = appConfig.currency
  return (
    <>
      <SubscribeButton
        activityId={activityId}
        amount={amount}
        userInfo={userInfo}
      >
        <span className="text-sm px-6">
          {t('profile.subscription.subscribeButton', {
            amount,
            currency,
          })}
        </span>
      </SubscribeButton>
      <p className="text-[1rem] text-xs mt-3">
        <Trans i18nKey="profile.subscription.subscribeTip">
          {t('profile.subscription.subscribeTip')}
        </Trans>
      </p>
    </>
  )
}

export const SubscriptionButtonWithTip = memo(
  SubscriptionButtonWithTipComponent
)
